import ReportPage from './ReportPage'

export default function SelloutReport({className = ''}: {className?: string}) {
  return <ReportPage type='sellout' className={className} />
}
